/**
 * @desc 确认退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RejectBillOperationDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/rejectBillComplete`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
